module.exports = __webpack_public_path__ + "06_face.d9512c88.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer1/06_face.png
// module id = ZOly
// module chunks = 0